export default __webpack_public_path__ + "static/media/miguel-lopes-3.b5c70934.jpg";